import { CustomerMetafields } from "~/types";
import SetupCustomWishlistButton from "../../../setup/components/setup/productDetail/SetupCustomWishlistButton.client";

export default function WishlistButton({ customer, handle }: { customer?: CustomerMetafields, handle: string }) {

    return (
        <SetupCustomWishlistButton customer={customer} handle={handle} />
    )
}